// Static SVG rendition of the NOORIN idea bulb for devices without WebGL.
export const BulbFallback = ({ className = "" }) => (
  <div aria-hidden data-testid="bulb-fallback" className={`pointer-events-none ${className}`}>
    <svg viewBox="0 0 300 420" className="h-full w-full">
      <defs>
        <radialGradient id="bf-halo" cx="50%" cy="38%" r="50%">
          <stop offset="0%" stopColor="#D8BB86" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#D8BB86" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="bf-glass" cx="42%" cy="30%" r="75%">
          <stop offset="0%" stopColor="#E6F1EB" stopOpacity="0.22" />
          <stop offset="100%" stopColor="#2F5F53" stopOpacity="0.12" />
        </radialGradient>
        <linearGradient id="bf-brass" x1="0" x2="1">
          <stop offset="0%" stopColor="#7E6238" />
          <stop offset="50%" stopColor="#C9A266" />
          <stop offset="100%" stopColor="#7E6238" />
        </linearGradient>
      </defs>
      <circle cx="150" cy="150" r="150" fill="url(#bf-halo)" />
      <path d="M150 20 C 225 20 262 78 262 140 C 262 192 226 214 204 248 C 196 262 194 276 194 290 L 106 290 C 106 276 104 262 96 248 C 74 214 38 192 38 140 C 38 78 75 20 150 20 Z" fill="url(#bf-glass)" stroke="#E6F1EB" strokeOpacity="0.45" strokeWidth="1.5" />
      <g fill="none" stroke="#F4D59C" strokeWidth="2" strokeLinecap="round">
        <path d="M138 290 L 145 200 M162 290 L 155 200 M150 205 L 150 168" />
        <path d="M150 168 L 104 128 M150 168 L 150 112 M150 168 L 196 128" />
        <path d="M104 128 L 86 96 M104 128 L 78 120 M150 112 L 136 80 M150 112 L 164 80 M196 128 L 214 96 M196 128 L 222 120" />
      </g>
      <g fill="url(#bf-brass)">
        <rect x="104" y="290" width="92" height="18" rx="4" />
        <rect x="108" y="312" width="84" height="12" rx="6" />
        <rect x="108" y="328" width="84" height="12" rx="6" />
        <rect x="108" y="344" width="84" height="12" rx="6" />
        <path d="M112 360 L 188 360 L 170 380 L 130 380 Z" />
        <rect x="140" y="382" width="20" height="8" rx="3" />
      </g>
    </svg>
  </div>
);
